export default __webpack_public_path__ + "static/media/server_white.a2ad0543.svg";